export const name: string = 'Data Edit';
export const moduleName: string = 'pdc-widget-data-edit';
export const icon: string = 'edit';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'pdc-widget-data-edit';

export const themeFields = {
    themeGroup_dataProcessing: 'widget-data-edit-group-dataProcessing',
    themeGroup_style: 'widget-data-edit-group-style',
    themeGroup_columnOptions: 'widget-data-edit-group-column-options',
    themeGroup_gridOptions: 'widget-data-edit-group-grid-options',
    themeGroup_gridSearchPanel: 'widget-data-edit-group-grid-search-panel',
    themeGroup_ToolbarButtons: 'widget-data-edit-group-toolbar-buttons',
    themeGroup_storeGridLayout: 'widget-data-edit-group-storeGridLayout',
    themeGroup_dialogOptions: 'widget-data-edit-dialog-options',
    themeGroup_WordWrap: 'data-edit-group-word-wrap',
    themeGroup_FilterRow: 'data-edit-group-filter-row',

    editingMode: 'data-edit-editing-mode',
    endlessScrolling: 'data-edit-endless-scrolling',
    allowInserting: 'data-edit-allow-inserting',
    allowUpdating: 'data-edit-allow-updating',
    allowDeleting: 'data-edit-allow-deleting',
    transactionMode: 'data-edit-transaction-mode',
    multiRowOperations: 'data-edit-multi-row-operations',

    titlePosition: 'widget-data-edit-title-position',
    titleWidth: 'widget-data-edit-title-width',
    verticalSpacing: 'widget-data-edit-vertical-spacing',
    styleBackgroundColor: 'widget-data-edit-background-color',
    styleToolbarBackgroundColor: 'widget-data-edit-toolbar-background-color',
    styleHeaderFontColor: 'widget-data-edit-header-font-color',
    styleHeaderBackgroundColor: 'widget-data-edit-header-background-color',
    styleGroupRowFontColor: 'widget-data-edit-group-row-font-color',
    styleGroupRowBackgroundColor: 'widget-data-edit-group-row-background-color',
    styleRowFontColor: 'widget-data-edit-row-font-color',
    styleRowBackgroundColor: 'widget-data-edit-row-background-color',

    styleRowAlternation: 'widget-data-edit-row-alternation',

    showRowLines: 'widget-data-edit-show-row-lines',
    showColumnLines: 'widget-data-edit-show-column-lines',
    gridLinesColor: 'widget-data-edit-grid-lines-color',
    editableCellsBackgroundColor: 'widget-data-edit-editable-cells-background-color',

    // Toolbar
    allowGrouping: 'widget-data-edit-allow-grouping',
    showToolbar: 'widget-data-edit-show-grid-toolbar',
    allowFilterRow: 'widget-data-edit-allow-filter-row',
    filterRowEnabled: 'widget-data-edit-filter-row-enabled',
    allowWordWrap: 'widget-data-edit-allow-word-wrap',
    wordWrapEnabled: 'widget-data-edit-word-wrap-enabled',
    showHistory: 'widget-data-edit-show-history',
    hideNoDataMessage: 'widget-data-edit-hide-no-data-message',

    // Various Options
    allowColumnFixing: 'widget-data-edit-allow-column-fix',
    allowColumnResize: 'widget-data-edit-allow-column-resize',
    columnResizingMode: 'widget-data-edit-column-resizing-mode',
    columnMinWidth: 'widget-data-edit-column-min-width',
    detailsComponentHeight: 'widget-data-edit-details-component-height',

    searchPanelShow: 'widget-data-edit-search-panel-show',
    searchPanelWidth: 'widget-data-edit-search-panel-width',

    columnChooserShow: 'widget-data-edit-column-chooser-show',
    columnChooserWidth: 'widget-data-edit-column-chooser-width',
    columnChooserHeight: 'widget-data-edit-column-chooser-height',

    resetLayoutButtonShow: 'widget-data-edit-reset-layout-button-show',
    showColumnHeaders: 'widget-data-edit-show-column-headers',

    // Store Layout
    storeGridLayout_resetLayoutAfterConfigurationChange:
        'widget-data-edit-storeGridLayout-resetLayoutAfterConfigurationChange'
};
